module.exports = __webpack_public_path__ + "static/Where_Next_2024_Front_Page.b12fa645.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Where_Next_2024_Front_Page.jpg
// module id = 53
// module chunks = 35783957827783 174759553322802 227638899823042